module.exports = __webpack_public_path__ + "static/img/coal_256.6a2c28b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coal_256.png
// module id = GeTg
// module chunks = 0